export default __webpack_public_path__ + "static/media/EchoAR.d4c58a01.png";